export const getCompanyCrunchbaseUrl = (companyName: string) => {
  return `https://www.crunchbase.com/organization/${companyName
    .toLowerCase()
    .replaceAll(' ', '-')}`;
};
